import { render, staticRenderFns } from "./ru.vue?vue&type=template&id=e99da124&scoped=true"
import script from "./ru.vue?vue&type=script&lang=js"
export * from "./ru.vue?vue&type=script&lang=js"
import style0 from "./ru.vue?vue&type=style&index=0&id=e99da124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99da124",
  null
  
)

export default component.exports